// extracted by mini-css-extract-plugin
export default {"wrapper":"OrientationNotice_wrapper__rjgBb","leaves":"OrientationNotice_leaves__COjvL","rotate":"OrientationNotice_rotate__9JXVr","copy":"OrientationNotice_copy__gWOQj"};